import clsx from "clsx";
import { useTranslation } from "react-i18next";

import { Typography } from "@atoms/typography";

import classes from "./styles.module.scss";

export function AuthFooter() {
  const { t } = useTranslation("common");

  return (
    <div className={clsx(classes.footer)}>
      <Typography fontType={"paragraph-small"} themeColor={"text-sub-600"}>
        {t("auth.footer")}
      </Typography>
    </div>
  );
}
